import { render, staticRenderFns } from "./BasicArrow.vue?vue&type=template&id=58cb92f2&scoped=true"
import script from "./BasicArrow.vue?vue&type=script&setup=true&lang=js"
export * from "./BasicArrow.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BasicArrow.vue?vue&type=style&index=0&id=58cb92f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cb92f2",
  null
  
)

export default component.exports